import React from 'react';
import { connect } from 'react-redux';
import LaunchDarklyClient from './LaunchDarklyClient';
import { currentClassRoomId } from '../../selectors/classroom';
import { institutionShortName } from '../../selectors/institution';
import { getCurrentUser } from '../../utils/currentUser';

const mapStateToProps = (state) => ({
  spaceId: currentClassRoomId(state),
  currentUserId: (getCurrentUser(state) || {}).id,
  institutionName: institutionShortName(state),
});

export default connect(mapStateToProps)(LaunchDarklyClient);
